'use strict';

angular.module('licensure.services')
    .factory('Alerts', ['$http', '$q', function ($http, $q) {
        return {
            getByID: function (id) {
                var d = $q.defer();

                $http
                    .get(apiLocation + '/api/Alerts/' + id, {
                        params: {

                        }
                    })
                    .then(function (response) {
                        d.resolve(response.data);
                    })
                    .catch(function (response) {
                        d.reject(response.data);
                    });

                return d.promise;
            },

            getAlerts: function (args) {
                var d = $q.defer();

                $http
                    .get(apiLocation + '/api/alerts/getalerts', {
                        params: args
                    })
                    .then(function (response) {
                        d.resolve(response.data);
                    })
                    .catch(function (response) {
                        console.log(response.data);
                        d.reject(response.data);
                    });

                return d.promise;
            },

            getDashboardAlerts: function (args) {
                var d = $q.defer();

                $http
                    .get(apiLocation + '/api/alerts/getDashboardAlerts', {
                        params: args
                    })
                    .then(function (response) {
                        d.resolve(response.data);
                    })
                    .catch(function (response) {
                        console.log(response.data);
                        d.reject(response.data);
                    });

                return d.promise;
            },

            getAlertsCount: function (args) {
                var d = $q.defer();

                $http
                    .get(apiLocation + '/api/alerts/getAlertsCount', {
                        params: args
                    })
                    .then(function (response) {
                        d.resolve(response.data);
                    })
                    .catch(function (response) {
                        console.log(response.data);
                        d.reject(response.data);
                    });

                return d.promise;
            },

            save: function (alert, value) {
                var d = $q.defer();
                var method = 'POST';
                var url = apiLocation + '/api/Alerts/';
                if (!isUndefined(alert.id)) {
                    method = 'PUT'
                    url += alert.id
                }

                $http({
                    method: method,
                    url: url,
                    data: {
                        alert: alert,
                        value: value
                    }
                })
                    .then(function (response) {
                        d.resolve(response.data);
                    })
                    .catch(function (response) {
                        d.reject(response.data);
                    });

                return d.promise;
            }
        }
    }])
;